export const terms = [
	{
		key: 'engagement_of_service',
		title: `Engagement of service`,
		multipleSelect: true ,
		terms: [
			{ 
				key:'autofilled_scope_of_services', 
				title: `Autofilled scope of services`,
				description: 'This services agreement is made on the Date (i.e 23 April), Year between "Client Name" , referred to in this agreement as “client”, and "Freelancer Name" referred to in this agreement as “freelancer”'
 			}
		]
	},
	{
		key: 'payment',
		title: `Payment`,
		hint: 'Select One',
		multipleSelect: false,
		terms: [
			{ 
				key:'100_percent_before_starting',
				title: `100% before starting`,
				description: `The client shall pay “Freelancer Name”, a flat fee of “Total amount on quotation” as total compensation for the project describes. Payment shall be made as follows:
a. “Total amount” due before work will begin.

The client is also responsible to pay any extra fees (bank or transfer) in conjunction with payment.The Payment should be made to the details mentioned in the “quote” section.`
			},
			{ 
				key:'50_percent_before_50_percent_after',
				title: `50% before, 50% after`,
				description: `The client shall pay “Freelancer Name”, a flat fee of “Total amount on quotation” as total compensation for the project described. Payment shall be made as follows:
a. “50% of Total amount on quotation” due before work will begin, and
b. “50% of Total amount on quotation” due upon receipt of all deliverables

The client is also responsible to pay any extra fees (bank or transfer) in conjunction with payment. The Payment should be made to the details mentioned in the “quote” section.`
			},
			{ 
				key:'100_percent_upon_completion',
				title: `100% upon completion`,
				description: `The client shall pay “Freelancer Name”, a flat fee of “Total amount on quotation” as total compensation for the project describes. Payment shall be made as follows:
a. “Total amount on quotation” due upon receipt of all deliverables

The client is also responsible to pay any extra fees (bank or transfer) in conjunction with payment. The Payment should be made to the details mentioned in the “quote” section.`
			},
		]
	},
	{
		key: 'prerequisites',
		title: `Prerequisites`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `Autofilled template`,
				description: `The client will provide “Freelancer Name” with the logo in .ai format and any colour palette and fonts needed.`
			}
		]
	},
	{
		key: 'assumptions',
		title: `Assumptions`,
		hint: 'May select multiple',
		multipleSelect: true,
		terms: [
			{ 
				key:'artwork_for_personal_use',
				title: `Artwork only to be used for personal use`,
				description: `The Deliverables may only be deployed for personal use by the Client, and may not under any circumstances be used for commercial purposes or for the financial benefit of the Client.`
			},
			{ 
				key:'artwork_may_not_reproduced',
				title: `Artwork may not be reproduced`,
				description: `The Client may not under any circumstances reproduce the Deliverables without the express written consent of the Freelancer. Any such violation of this clause will constitute a breach of the Freelancers proprietary rights, and will entitle the Freelancer to claim damages from the Client.`
			},
			{ 
				key:'artwork_only_use_in_specific_location',
				title: `Artwork may only be used in specific location`,
				description: `The Deliverables may only be used by the Client in (-location-)`
			},
			{ 
				key:'client_may_not_represent_deliverables',
				title: `Client may not represent deliverables as their own`,
				description: `The Client may not represent the Deliverables as their own work.`
			},
			{ 
				key:'artwork_for_limited_time',
				title: `Artwork may only be used for limited time`,
				description: `The Client may only display the Deliverables for (-) months/years.`
			},
			{ 
				key:'artwork_only_use_in_public',
				title: `Artwork may only be used in public spaces`,
				description: `The Client may not display the Deliverables in public spaces.`
			}
		]
	},
	{
		key: 'terminations',
		title: `Termination`,
		hint: 'May select multiple',
		multipleSelect: true,
		terms: [
			{ 
				key:'written_agreement',
				title: `Written Agreement`,
				description: `This agreement may be terminated at any time by the written mutual agreement of both Parties.`
			},
			{ 
				key:'completion_upon_payment',
				title: `Completion upon payment`,
				description: `This agreement will terminate upon the completion of the Payment by the Client and the delivery of the Deliverables by the Freelancer.`
			},
			{ 
				key:'failure_to_pay',
				title: `Failure to pay`,
				description: `Should the Client fail to make payment in accordance with the “Payment” section of this agreement, the Freelancer may terminate this agreement at their sole discretion and invoice the Client for works completed up until that point.`
			},
			{ 
				key:'failute_to_pay_on_time',
				title: `Failure to pay on time`,
				description: `Should the Client fail to make payment in accordance with the “Payment” section of this agreement, the Freelancer may terminate this agreement within ten (10) days notice to the Client regarding such failure, and provided the Client does not complete payment within that ten (10) day period.`
			}
		]
	},
	{
		key: 'single_point_of_contact',
		title: `Single point of contact`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `Autofilled template`,
				description: `All communication, feedback and revision request will be between the client “Client Name” and “Freelancer Name” only.`
			}
		]
	},
	{
		key: 'kill_fee',
		title: `Kill fee`,
		hint: 'May select one only',
		multipleSelect: true,
		terms: [
			{ 
				key:'non_refundable_50_percent',
				title: `Non-refundable 50%`,
				description: `If, for any reason, the project will be canceled after the start, “Freelancer Name” will not be obliged to repay the client the first payment`
			},
			{ 
				key:'autofilled_template',
				title: `Autofilled template`,
				description: `If, for any reason, the project will be canceled after the start, Freelancer may terminate this agreement at their sole discretion and invoice the Client for works completed up until that point.`
			}
		]
	},
	{
		key: 'revisions',
		title: `Revisions`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `Autofilled template`,
				description: `2-3 concepts will be presented to the client. After the both parts agreed and signed of on a concept, then the client can’t at this stage go back and change concept. During the animations process the client has 2 free revisions.`
			}
		]
	},
	{
		key: 'revisions_after_deadline',
		title: `Revisions after deadline`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `Autofilled template`,
				description: `If the client, after the delivery, want some changes made, the client will need to set up a new contract with “Freelancer Name” and pay extra for any additional requirements.`
			}
		]
	},
	{
		key: 'deadline',
		title: `Deadline`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `Autofilled template`,
				description: `Date of deadline is the 20th of July 2019. By then “Freelancer Name” will deliver “Deliverables” and the client will make his/her last payment (Refer to Payment)`
			}
		]
	}
]

export const arabicTerms = [
	{
		key: 'engagement_of_service',
		title: `الاتفاق على الخدمات`,
		multipleSelect: true ,
		terms: [
			{ 
				key:'autofilled_scope_of_services', 
				title: `نطاق الخدمات المعبأ تلقائيًا`,
				description: 'حرّرت هذه الاتفاقية بتاريخ "(مثال 23 أبريل) السنة"، بين "اسم العميل" المشار إليه في الاتفاقية بلفظ "العميل"، و"اسم الموظف الحرّ" المشار إليه في الاتفاقية بلفظ "الموظف الحرّ".'
 			}
		]
	},
	{
		key: 'payment',
		title: `السداد`,
		hint: 'اختر واحد',
		multipleSelect: false,
		terms: [
			{ 
				key:'100_percent_before_starting',
				title: `100% قبل البدء `,
				description: `يسدّد العميل لـ "اسم الموظف الحرّ" أجرًا مقطوعًا قيمته "المبلغ الإجمالي المعروض" ككامل ثمن المشروع المبيّن. وتسدّد الدفعة على الشكل التالي:
أ. كامل المبلغ المستحق قبل بدء العمل.
ويتحمل العميل أيضًا مسؤولية دفع أي رسوم إضافية (رسوم البنك أو التحويل) مرتبطة بسداد الدفعة هذه. ويجب سداد الدفعة وفق التفاصيل المذكورة في قسم "عرض الأسعار".`
			},
			{ 
				key:'50_percent_before_50_percent_after',
				title: `50% قبل البدء، و50% بعد الانتهاء`,
				description: `يسدّد العميل لـ "اسم الموظف الحرّ" أجرًا مقطوعًا قيمته "المبلغ الإجمالي المعروض" ككامل ثمن المشروع المبيّن. وتسدّد الدفعات على الشكل التالي:
أ. 50% من إجمالي المبلغ المعروض تُسدّد قبل بدء العمل؛
ب. 50% من إجمالي المبلغ المعروض تُسدّد بعد استلام جميع منجزات المشروع؛
ويتحمل العميل أيضًا مسؤولية دفع أي رسوم إضافية (رسوم البنك أو التحويل) مرتبطة بسداد الدفعة هذه. ويجب سداد الدفعة وفق التفاصيل المذكورة في قسم "عرض الأسعار".`
			},
			{ 
				key:'100_percent_upon_completion',
				title: `100% بعد الانتهاء`,
				description: `يسدّد العميل لـ "اسم الموظف الحرّ" أجرًا مقطوعًا قيمته "المبلغ الإجمالي المعروض" ككامل ثمن المشروع المبيّن. وتسدّد الدفعة على الشكل التالي:   

أ‌. "كامل المبلغ المعروض" يسدّد بعد استلام جميع منجزات المشروع.
ويتحمل العميل أيضًا مسؤولية دفع أي رسوم إضافية (رسوم البنك أو التحويل) مرتبطة بسداد الدفعة هذه. ويجب سداد الدفعة وفق التفاصيل المذكورة في قسم "عرض الأسعار".`
			},
		]
	},
	{
		key: 'prerequisites',
		title: `الشروط المسبقة`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `نموذج معبأ تلقائيًا (انقر للتحرير)`,
				description: `يزوّد العميل "اسم الموظف الحرّ" بالشعار اللازم بصيغة ملف ".ai" وباقة الألوان والخطوط المختارة اللازمة.`
			}
		]
	},
	{
		key: 'assumptions',
		title: `الافتراضات`,
		hint: 'يجوز اختيار أكثر من خيار',
		multipleSelect: true,
		terms: [
			{ 
				key:'artwork_for_personal_use',
				title: `لا تستخدم الأعمال الفنّية سوى لأغراض شخصية`,
				description: `لا يجوز أن يستخدم العميل منجزات المشروع إلا لأغراض شخصية. ولا يجوز في أي ظرفٍ استخدامها لأغراض تجارية أو لمصلحة مادية للعميل.`
			},
			{ 
				key:'artwork_may_not_reproduced',
				title: `لا يجوز إعادة إنتاج الأعمال الفنّية`,
				description: `لا يجوز للعميل في أي ظرف كان أن يعيد إنتاج المنجزات من دون الموافقة الخطّية الصريحة للموظف الحرّ. ويعتبر أي انتهاك لهذا البند انتهاكًا للحقوق الخاصة التي يملكها الموظف الحرّ، ويحقّ للأخير مطالبة العميل بتعويض عن الضرر.`
			},
			{ 
				key:'artwork_only_use_in_specific_location',
				title: `لا يجوز استخدام الأعمال الفنّية سوى في مواقع معيّنة`,
				description: `يستخدم العميل منجزات المشروع حصرًا في (-الموقع-).`
			},
			{ 
				key:'client_may_not_represent_deliverables',
				title: `لا يجوز أن يقدّم العميل المنجزات على أنها من صنعه`,
				description: `لا يجوز للعميل أن يقدّم المنجزات على أنها من صنعه.`
			},
			{ 
				key:'artwork_for_limited_time',
				title: `لا يجوز استخدام الأعمال الفنّية إلا لوقت محدّد`,
				description: `لا يجوز للعميل أن يعرض المنجزات إلا لمدّة (-) أشهر/سنوات.`
			},
			{ 
				key:'artwork_only_use_in_public',
				title: `لا يجوز استخدام الأعمال الفنّية في الأماكن العامة`,
				description: `لا يجوز للعميل أن يعرض المنجزات في أماكن عامة.`
			}
		]
	},
	{
		key: 'terminations',
		title: `إنهاء الاتفاقية`,
		hint: 'يجوز اختيار أكثر من خيار',
		multipleSelect: true,
		terms: [
			{ 
				key:'written_agreement',
				title: `الاتفاقيات الخطية`,
				description: `يجوز إنهاء هذه الاتفاقية في أي وقتٍ كان بموافقة الطرفين معًا.`
			},
			{ 
				key:'completion_upon_payment',
				title: `الإكمال عند السداد`,
				description: `تنتهي هذه الاتفاقية عندما يسدّد العميلُ الدفعة بالكامل، ويسلّم الموظّفُ الحرُّ المنجزات بالكامل أيضًا.`
			},
			{ 
				key:'failure_to_pay',
				title: `عدم السداد`,
				description: `إذا لم يسدّد العميل الدفعة وفقًا للشروط التي ينصّ عليها قسم "السداد" في هذه الاتفاقية، يجوز أن يفسخ الموظّف الحرّ هذه الاتفاقية وفقًا لمطلق تقديره ويُرسل فاتورة للعميل بالأعمال المنجزة إلى حينه.`
			},
			{ 
				key:'failute_to_pay_on_time',
				title: `عدم السداد في الموعد المحدّد`,
				description: `إذا لم يسدّد العميل الدفعة وفقًا للشروط التي ينصّ عليها قسم "السداد" في هذه الاتفاقية، يجوز أن يفسخ الموظّف الحرّ هذه الاتفاقية بموجب إشعار يرسله إلى العميل قبل عشرة (10) أيام يبلغه بعدم السداد، بشرط ألا يستكمل العميل سداد الدفعة ضمن مهلة الأيام العشرة (10) هذه.`
			}
		]
	},
	{
		key: 'single_point_of_contact',
		title: `نقطة الاتصال الواحدة`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `نموذج معبأ تلقائيًا (انقر للتحرير)`,
				description: `يتم تبادل جميع الاتصالات والملاحظات وطلبات المراجعة بين العميل "اسم العميل" و"اسم الموظّف الحرّ" حصرًا.`
			}
		]
	},
	{
		key: 'kill_fee',
		title: `رسم الوقف الفوري `,
		hint: 'اختر خيارًا واحدًا فقط',
		multipleSelect: true,
		terms: [
			{ 
				key:'non_refundable_50_percent',
				title: `50% غير قابل للاسترداد`,
				description: `If, for any reason, the project will be canceled after the start, “Freelancer Name” will not be obliged to repay the client the first payment`
			},
			{ 
				key:'autofilled_template',
				title: `نموذج معبأ تلقائيًا (انقر للتحرير)`,
				description: `إذا تم إلغاء المشروع لأي سببٍ كان بعد بدايته، لا يكون "اسم الموظّف الحرّ" ملزمًا بإرجاع الدفعة الأولى للعميل.`
			}
		]
	},
	{
		key: 'revisions',
		title: `المراجعات`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `نموذج معبأ تلقائيًا (انقر للتحرير)`,
				description: `يتم تقديم 2-3 مفاهيم تصميمية للعميل. وبعد أن يوافق الطرفان ويعتمدا المفهوم المختار، لا يجوز أن يتراجع العميل في هذه المرحلة عن المفهوم المعتمد ولا يجوز أن يغيّره. ويملك العميل حقّ طلب مراجعتين مجانيتين خلال عملية الرسم المتحرّك.`
			}
		]
	},
	{
		key: 'revisions_after_deadline',
		title: `المراجعات  بعد  الموعد النهائي`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `نموذج معبأ تلقائيًا (انقر للتحرير)`,
				description: `إذا أراد العميل بعد التسليم إجراء بعض التغييرات، يتعيّن على العميل صياغة عقدٍ جديدٍ مع "اسم الموظّف الحرّ" ودفع مبلغ إضافي لأي متطلبات أخرى.`
			}
		]
	},
	{
		key: 'deadline',
		title: `الموعد النهائي`,
		multipleSelect: true,
		terms: [
			{ 
				key:'autofilled_template',
				title: `نموذج معبأ تلقائيًا (انقر للتحرير)`,
				description: `يكون الموعد النهائي في 20 يوليو 2019. وفي هذا الموعد، يسلّم "اسم الموظّف الحرّ" للعميل "المنجزات"، ويسدّد العميل الدفعة الأخيرة المتوجبة عليه/عليها (راجع قسم "السداد").`
			}
		]
	}
];

export function getTerms() {
	return (window as any).LOCALE == 'ar' ? arabicTerms : terms;
}